import React, { useEffect, useState } from "react";
import { Card, CardContent, Typography, Box, Link, Button } from "@mui/material";
import { useForm } from "react-hook-form";
import InputWrapper from "../../../../../obps/src/pages/citizen/AVPForms/layout/inputWrapper";
import { useLocation, useHistory } from "react-router-dom";
import { Toast } from "@egovernments/digit-ui-react-components";

const ResetPasswordRecovery = () => {
  const { control, handleSubmit } = useForm();
  const getUserType = () => Digit.UserService.getType();
  const location = useLocation();
  const navigate = useHistory();
  const [showToast, setShowToast] = useState(null);

  const { otp, tenantId, mobileNumber, uuid, userType } = location.state || {};

  const onSubmit = async (data) => {
    if (data.newPassword !== data.confirmPassword) {
      setShowToast({ key: true, message: "Password doesnot match. Please try again." });
      return;
    }

    const requestData = {
      userName: mobileNumber,
      newPassword: data.newPassword,
      otpReference: otp,
      tenantId,
      type: userType.toUpperCase()
    };

    try {
      await Digit.UserService.changePasswordNoLogin(requestData, tenantId);
      setShowToast({ key: "success", message: "Password changed successfully" });
      setTimeout(() => navigate.push("/digit-ui/citizen"), 3000)
    } catch (err) {
      console.error("Reset Password Error:", err);
      alert(err?.response?.data?.Errors?.[0]?.message || "Unable to reset password");
    }
  };
  const closeToast = () => {
    setShowToast(null);
  };
  // useEffect(() => {
  //   if (!otp || !tenantId) {
  //     navigate.push("/digit-ui/citizen");
  //   }
  // }, []);

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" sx={{ backgroundColor: "#0F4C75" }}>
      <Card sx={{ width: 420, borderRadius: 2 }}>
        <CardContent>
          <Typography variant="h6" align="center" fontWeight="bold" gutterBottom>
            RESET PASSWORD
          </Typography>

          <Typography variant="body2" align="center" color="text.secondary" mb={3}>
            Please set your new password below following the criteria.
          </Typography>

          <form onSubmit={handleSubmit(onSubmit)}>
            <InputWrapper
              control={control}
              label="Enter your new Password"
              name="newPassword"
              type="password"
              width={390}
              isPassword={true}
              mandatory
              validation={{
                required: {
                  value: true,
                  message: "Password is required",
                },
              }}
            />

            <Box mt={2}>
              <InputWrapper
                control={control}
                label="Re-Enter your new Password"
                name="confirmPassword"
                type="password"
                mandatory
                isPassword={true}
                width={390}
                validation={{
                  required: {
                    value: true,
                    message: "Confirm password is required",
                  },
                }}
              />
            </Box>

            <Box mt={2}>
              <Typography variant="body2" color="text.secondary">
                • Password must contain at least 8 characters <br />
                • At least one special character <br />
                • At least one number <br />
                • At least one uppercase letter <br />• At least one lowercase letter
              </Typography>
            </Box>

            <Box mt={3}>
              <Button
                fullWidth
                variant="contained"
                type="submit"
                sx={{
                  backgroundColor: "#1F4A7C",
                  "&:hover": {
                    backgroundColor: "#163A63",
                  },
                }}
              >
                Continue
              </Button>
            </Box>
          </form>

          <Box mt={2} textAlign="center">
            <Link href="/digit-ui/citizen" underline="hover">
              Back to Login Page
            </Link>
          </Box>
        </CardContent>
        {showToast && (
          <Toast error={showToast?.error} warning={showToast?.warning} label={showToast.key === "success" ? showToast?.message: showToast?.message} onClose={closeToast} isDleteBtn={true} />
        )}
      </Card>
    </Box>
  );
};

export default ResetPasswordRecovery;
